import { createSelector } from 'reselect'
import { getFreeTrialEndedAtUserSelect } from 'modules/training/modules/training-users/selectors/get-free-trial-ended-at/index.js'

export const hasFreeTrialEndedUserSelect = createSelector(
  getFreeTrialEndedAtUserSelect,
  (endedAt) => !!endedAt
)
